import { useCallback } from 'react';
import { navigateTo } from '../utils/navigation';


export const useLegacyOkrPopupHandlers = () => {

  const handleOkrDetailPopup = useCallback(
    (id) => {
    const newUrl = `/wb/okrs/objectives/${id}`;

    if (!window.goalDetailsCallbackUrl) {
      window.goalDetailsCallbackUrl = window.location.href.includes(newUrl)
        ? ''
        : window.location.href;
      }
      const preURL = window.location.href;
      const params = {
        id,
        onModalCloseCallback: () => {
          if (window.goalDetailsCallbackUrl) {
            navigateTo(window.goalDetailsCallbackUrl);
            window.goalDetailsCallbackUrl = '';
          } else {
            navigateTo(
              preURL.includes('/wb/okrs/objectives/') ? '/wb/okrs' : preURL,
            );
          }
        },
      };

      if (!preURL.includes(newUrl)) {
        window.history.pushState('', '', newUrl);
      }

      window.viewGoalDetailsPage?.(undefined, params);
    },
    [],
  );

  return {
    handleOkrDetailPopup,
  };
};
